export const SET_LOADED_LINKS = 'SET_LOADED_LINKS';

export const SET_GUIDE_APP_FLAG = 'SET_GUIDE_APP_FLAG';

export const SET_GUIDE_BROWSER_FLAG = 'SET_GUIDE_BROWSER_FLAG';

/**
 * @description 保存用户数据
 */
export const SET_USER_DATA = 'SET_USER_DATA';
